import { useEffect } from 'react';
import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import type { TaskDragData } from './useTaskDraggable';
import type { TaskStatus } from '../../types';

export type MovePayload = {
  source_id: number;
  status: TaskStatus;
  type: 'before' | 'after';
  target_id: number; //  -1  into empty group
};

export function useTaskDragMonitor(onTaskMove: (moveData: MovePayload) => void): void {
  useEffect(() => {
    return monitorForElements({
      canMonitor({ source }) {
        const sourceData = source.data as TaskDragData;
        return typeof sourceData.taskId === 'number';
      },
      onDrop({ location, source }) {
        const target = location.current.dropTargets[0];
        if (!target) {
          return;
        }

        const sourceData = source.data as TaskDragData;
        const targetData = target.data as TaskDragData;
        const edge = extractClosestEdge(targetData) as 'bottom' | 'top';

        const moveData: MovePayload = {
          source_id: sourceData.taskId,
          status: targetData.currentStatus,
          target_id: targetData.taskId,
          type: edge === 'bottom' ? 'after' : 'before',
        };

        onTaskMove(moveData);
      },
    });
  }, [onTaskMove]);
}
